import React from 'react'
import podAndHiveLogo from '../../assets/podAndHiveLogo.svg'
import { Body, Box } from '../layout'

export const MadeByPodAndHive = (props) => (
  <a href="https://www.podandhive.com" target="_blank" rel="noreferrer" style={{ textDecoration: 'none' }} {...props}>
    <Box alignItems="center" gap={8}>
      <Body color="white" noWrap size={16}>made by</Body>
      <img src={podAndHiveLogo} alt="Pod and Hive Logo" style={{ height: 14 }}/>
    </Box>
  </a>
)